<template>
  <div class="slide-navigation-item m-2 p-0 btn btn-secondary" tabindex="0" :class="{ 'disabled': disabled }"
    @click.prevent="$emit('goToSlide', slide.id)">
    <div class="p-2 text-light rounded-top" :class="{ 'bg-theme': active }">
      <h6 class="text-truncate mb-0">{{ title }}</h6>
    </div>
    <PreviewSlide :slide="slide"></PreviewSlide>
    <div class="p-2 text-light d-flex justify-content-between align-items-center rounded-bottom" :class="{ 'bg-theme': active }">
      <span class="font-weight-bold">{{ slide.position }}</span>
      <div>
        <i v-if="isBallot && slide.state == 'finished'" class="fas fa-poll me-1" v-tooltip="$t('js.tooltips.result_ready')"></i>
        <i v-if="typeIcon" :class="typeIcon" v-tooltip="$t('js.tooltips.ballot')"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "pinia";
import { defineComponent } from "vue";
import PreviewSlide from "./PreviewSlide.vue";
import { useSharedStore } from "@/entrypoints/stores/shared";
import type { PropType, Slide } from "@/types";

export default defineComponent({
  name: "SlideNavigation",
  components: { PreviewSlide },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    slide: {
      type: Object as PropType<Slide>,
      default: () => {
        return { type: "none" }
      },
    },
  },
  computed: {
    ...mapState(useSharedStore, ["firstAvailableLocale"]),
    title() {
      let title = this.slide.internalName
        ? this.slide.internalName
        : this.slide.title[this.firstAvailableLocale];

      if (title === "" || title === undefined)
        title = this.$t("js.slide.one") + " #" + this.slide.position;

      return title;
    },
    description() {
      return this.slide.description[this.firstAvailableLocale];
    },
    isBallot() {
      return this.slide.type === "Slides::BallotSlide";
    },
    typeIcon() {
      if (this.isBallot) return "fas fa-vote-yea"
    },
    backgroundStyle() {
      if (this.slide.background) {
        return {
          backgroundImage: `url("${this.slide.background}")`,
          backgroundAttachment: "local",
          backgroundSize: "cover",
        };
      } else {
        return { backgroundColor: "#fff" };
      }
    }
  },
  mounted() {
    $('[data-bs-toggle="tooltip"]').tooltip();
  }
});
</script>
